import { createSelector } from "reselect";
import { MODULE_NAME } from './core.constants'
import { ICurrentUser, IState } from "./core.types";

const selectState = (state: { [MODULE_NAME]: IState }): IState => state[MODULE_NAME]

export const getCurrentUser = createSelector(selectState, (state: IState): ICurrentUser => state.currentUser)